/** @type {const} */
export const themesCacheKeys = {
  themes: 'themes',
  themesWithActivities: 'themesWithActivities',
  version: 'themesVersion',
};
